import { render, staticRenderFns } from "./Deliverymen.vue?vue&type=template&id=f536bbf6&scoped=true"
import script from "./Deliverymen.vue?vue&type=script&lang=js"
export * from "./Deliverymen.vue?vue&type=script&lang=js"
import style0 from "./Deliverymen.vue?vue&type=style&index=0&id=f536bbf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f536bbf6",
  null
  
)

export default component.exports